import {
  ADD_PRODUCT,
  CLEAR_CREATE_PRODUCT_ERROR,
  CLEAR_UPDATE_PRODUCT_ERROR,
  CLOSE_CREATE_PRODUCT_MODAL,
  CLOSE_UPDATE_PRODUCT_MODAL,
  CREATE_PRODUCT_ERROR,
  CREATE_PRODUCT_PENDING,
  CREATE_PRODUCT_SUCCESS,
  GET_PRODUCTS_PENDING,
  OPEN_CREATE_PRODUCT_MODAL,
  OPEN_UPDATE_PRODUCT_MODAL,
  PRODUCT_LIST_ERROR,
  SET_ASSIGNABLE_PRODUCTS_LIST_ASYNC,
  SET_PRODUCTS_LIST,
  SET_PRODUCT_DETAILS,
  UPDATE_PRODUCT_ERROR,
  UPDATE_PRODUCT_PENDING,
  UPDATE_PRODUCT_SUCCESS
} from "../products/actionTypes";

const initialState = {
  //--------------------------------PRODUCT-LIST------------------------------------------------
  isGetProductsPending: false,
  products: [],
  totalRecords: null,
  productListError: null,
  //--------------------------------PRODUCT-CREATE----------------------------------------------
  isCreateProductModalOpen: false,
  isCreatePending: false,
  AddProductForm: {},
  errorMessage: null,
  //--------------------------------PRODUCT-EDIT------------------------------------------------
  isUpdateProductModalOpen: false,
  isUpdatePending: false,
  productDetails: {},
  updateProductError: null,

};

export default (localState = initialState, action) => {
  switch (action.type) {
    //--------------------------------PRODUCT-LIST------------------------------------------------
    case GET_PRODUCTS_PENDING: {
      return {
        ...localState,
        isGetProductsPending: true,
      };
    }

    case SET_PRODUCTS_LIST: {
      const { productsOdata } = action.payload;
      return {
        ...localState,
        isGetProductsPending: false,
        productListError: null,
        products: productsOdata && productsOdata.value,
        totalRecords: productsOdata && productsOdata['@odata.count'],
      };
    }

    case PRODUCT_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        productListError: errorMessage,
        isGetProductsPending: false,
        products: [],
        totalRecords: 0
      };
    }

    //--------------------------------PRODUCT-CREATE----------------------------------------------
    case OPEN_CREATE_PRODUCT_MODAL: {
      return {
        ...localState,
        isCreateProductModalOpen: true,
        errorMessage: null,
      };
    }

    case CLOSE_CREATE_PRODUCT_MODAL: {
      return {
        ...localState,
        isCreateProductModalOpen: false,
      };
    }
    case ADD_PRODUCT: {
      const { AddProductForm } = action.payload;
      return {
        ...localState,
        AddProductForm: AddProductForm
      };
    }
    case CREATE_PRODUCT_SUCCESS: {
      return {
        ...localState,
        isCreatePending: false,
      };
    }

    case CREATE_PRODUCT_PENDING: {
      return {
        ...localState,
        isCreatePending: true,
      };
    }

    case CREATE_PRODUCT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isCreatePending: false,
      };
    }

    case CLEAR_CREATE_PRODUCT_ERROR: {
      return {
        ...localState,
        errorMessage: null,
      };
    }

    case SET_ASSIGNABLE_PRODUCTS_LIST_ASYNC: {
      const { productsListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        productsListAsync: productsListAsync,
        searchValueAsync
      }
    }
    //--------------------------------PRODUCT-EDIT------------------------------------------------
    case OPEN_UPDATE_PRODUCT_MODAL: {
      return {
        ...localState,
        isUpdateProductModalOpen: true,
        errorMessage: null,
      };
    }

    case CLOSE_UPDATE_PRODUCT_MODAL: {
      return {
        ...localState,
        isUpdateProductModalOpen: false,
      };
    }

    case SET_PRODUCT_DETAILS: {
      const { productDetails } = action.payload;
      return {
        ...localState,
        productDetails: productDetails
      }
    }

    case UPDATE_PRODUCT_PENDING: {
      return {
        ...localState,
        isUpdatePending: true,
      };
    }
    case UPDATE_PRODUCT_SUCCESS: {
      return {
        ...localState,
        isUpdatePending: false,
      };
    }

    case UPDATE_PRODUCT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        updateProductError: errorMessage,
        isUpdatePending: false,
      };
    }

    case CLEAR_UPDATE_PRODUCT_ERROR: {
      return {
        ...localState,
        updateProductError: null,
      };
    }

    default: {
      return localState;
    }
  }
};
